import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    artists: [],
    dialog: false,
    allArtists: []
  },

  mutations: {
    setArtists(state, payload) {
      state.artists = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setAllArtists(state, payload) {
      state.allArtists = payload
    }
  },

  actions: {
    read({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/new-releases')
        .then(r => {
          commit('setArtists', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ commit, dispatch }, id) {
      axios.admin
        .put('cms/new-releases/' + id)
        .then(() => {
          commit('setDialog', false)
          dispatch('read')
        })
    },
    delete({ commit, dispatch }, id) {
      axios.admin
        .put('cms/new-releases/delete/' + id)
        .then(() => {
          commit('setDialog', false)
          dispatch('read')
        })
    },
    getArtists({ commit }) {
      commit('setLoading', true)
      axios.admin
        .get('cms/new-releases/artists')
        .then(r => {
          commit('setAllArtists', r.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
